import { AutogenModelRapidAlertCtrl, AutogenRowRapidAlertCtrl } from "./autogen/AutogenModelRapidAlertCtrl";

export class ModelRapidAlertCtrl extends AutogenModelRapidAlertCtrl<RowRapidAlertCtrl> {
	constructor() {
		super(RowRapidAlertCtrl);
	}
}

export class RowRapidAlertCtrl extends AutogenRowRapidAlertCtrl {
}